import { Navigate, Outlet, useLocation } from 'react-router';
import { useMe } from '../api/queries';
import { Spinner } from './ui';

export function RequireAuth() {
  const { data: user, isPending } = useMe();
  const location = useLocation();

  if (isPending) return <Spinner />;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <Outlet />;
}
